module.exports = __webpack_public_path__ + "static/img/4813_phase_function_Paper_Points.1d2da3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4813_phase_function_Paper_Points.png
// module id = RTDu
// module chunks = 0